if (!customElements.get('rotating-banner')) {
  class RotatingBanner extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-rotating-banner-slide]'));
      this.index = 0;
      if (this.slides.length < 2) return;

      const prev = this.querySelector('[data-rotating-banner-prev]');
      const next = this.querySelector('[data-rotating-banner-next]');
      prev && prev.addEventListener('click', () => this.show(this.index - 1, true));
      next && next.addEventListener('click', () => this.show(this.index + 1, true));

      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.start());
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', () => this.start());

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.start();
    }

    disconnectedCallback() {
      this.stop();
    }

    get autorotate() {
      return this.dataset.autorotate === 'true' && !this.reducedMotion.matches;
    }

    start() {
      if (!this.autorotate || this.timer) return;
      const seconds = parseInt(this.dataset.interval, 10) || 5;
      this.timer = setInterval(() => this.show(this.index + 1, false), seconds * 1000);
    }

    stop() {
      clearInterval(this.timer);
      this.timer = null;
    }

    show(index, userInitiated) {
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => {
        slide.hidden = i !== this.index;
        slide.classList.toggle('is-active', i === this.index);
      });
      if (userInitiated) {
        this.stop();
        this.start();
      }
    }
  }

  customElements.define('rotating-banner', RotatingBanner);
}
